import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20" data-testid="auth-loading">
        <p className="font-mono text-xs tracking-[0.3em] text-kult-muted">CHECKING SESSION...</p>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    const dest = user.role === "admin"
      ? "/portal/admin"
      : user.role === "artist"
      ? "/portal/artist"
      : "/portal/customer";
    return <Navigate to={dest} replace />;
  }
  return children;
};
